const lightTheme = {
  name: 'Light',
  colors: {
    primary: {
      blue: {
        900: '#0D46A1',
        800: '#1564C0',
        700: '#1A75D2',
        400: '#42A4F5',
        500: '#429bf5',
        medium: '#E8F1FB',
        off: '#F2F8FD',
        extraLight: '#F9FBFE',
      },
      green: {
        900: '#1B5E20',
        800: '#2E7D32',
        700: '#388E3C',
        400: '#66BB6A',
        medium: '#E0F1E1',
        off: '#F1FAF1',
        extraLight: '#F4FAF4',
      },
      royalBlue: {
        900: '#222E58',
        800: '#2c3e70',
        600: '#33487d',
        dark: '#171F3B',
        medium: '#DFE4F1',
        off: '#F0F2FA',
        extraLight: '#F4F6FA',
      },
    },
    secondary: {
      red: {
        900: '#B02016',
        800: '#BF2A22',
        700: '#CC3229',
        50: '#FDF1F0',
        25: '#FAF5F5',
      },
      orange: {
        900: '#e35209',
        800: '#ed6c0b',
        700: '#F37B0C',
        50: '#FEF7F0',
        25: '#FAF7F5',
      },
    },
    neutral: {
      darkBlue: {
        900: '#142433',
        700: '#344a5f',
        400: '#697F99',
        200: '#A3B3C7',
        100: '#C3D2E1',
        50: '#E5EDF9',
        25: '#FAFBFD',
        15: '#999999',
      },
      white: '#FFFFFF',
      black: '#000000',
    },
    accent: {
      gold: {
        900: '#b05f0c',
        800: '#B9811C',
        50: '#F2EADA',
        25: '#FAF6F0',
        15: '#F5EDE0',
        dark: '#914E0A',
      },
      yellow: {
        600: '#f9ab00',
        500: '#f8b900',
        400: '#F9C200',
        50: '#FEF9E6',
        25: '#FFFCF0',
      },
      teal: {
        900: '#004D40',
        800: '#00695C',
        700: '#00796B',
        50: '#DAF2EF',
        25: '#F5FAF9',
      },
    },
  },
  typography: {
    fontWeight: {
      regular: 400,
      medium: 500,
      semiBold: 600,
      bold: 700,
    },
    fontSize: {
      tiny: '10px',
      sm: '11px',
      reg: '12px',
      med: '14px',
      std: '16px',
      lg: '18px',
      xl: '20px',
      xxl: '24px',
      xxxl: '28px',
    },
    lineHeight: {
      tiny: '12px',
      sm: '16px',
      reg: '20px',
      med: '24px',
      std: '28px',
      lg: '32px',
    },
  },
  spacing: {
    cornerRadius: {
      none: '0px',
      xs: '4px',
      sm: '8px',
      md: '20px',
      pill: '999px',
    },
    padding: {
      none: '0px',
      xs: '4px',
      sm: '8px',
      md: '16px',
      lg: '24px',
      xl: '32px',
    },
    margin: {
      none: '0px',
      xs: '4px',
      sm: '8px',
      md: '16px',
      lg: '24px',
      xl: '32px',
    },
    gutter: {
      none: '0px',
      xs: '4px',
      sm: '12px',
      md: '16px',
      lg: '24px',
    },
  },
  blue: {
    off: '#f2f8fe',
    extraLight: '#f9fbfe',
    light: '#42a5f5',
    medium: '#e8f1fb',
    dark: '#1976d2',
    grey: '#b0bec5',
    greyLight:'#8195ac',
    iconBg: '#f2f8fd',
    mild: '#F7F9FA',
    hippi: '#46a3a7',
    fullExtraLight: '#f1f8ff',
    chill: '#0c7eaf',
    greenishBlue: '#13B2B5',
    royal: '#2C3E70',
    borderBlue: '#a4d6fe',
    lightblue: '#f6f8fb',
    darkBlue: '#344A5F',
    slateBlue: '#4B62A1',
    midBlue: '#E7F4FF',
    bright:'#4caf50',
  },
  green: {
    off: '#f1faf1',
    extraLight: '#ecf7ec',
    light: '#66bb6a',
    milkyGreen: '#B6EBB9',
    medium: '#e0f1e1',
    dark: '#388e3c',
    range: '#7fd482',
    switchgreen: '#34c759',
    gradientLight: '#119f4a',
    gradientDark: '#078174',
    darkGreen: '#388E3C',
    borderGreen: '#b5e1ba',
    lightGreen: '#ECF7EC',
  },
  orange: {
    off: '#faf7f5',
    dark: '#e35209',
  },
  purple: {
    off: '#f6f3fc',
    light: '#7e57c2',
    dark: '#512da8',
    lighter: '#f6efff',
  },
  teal: {
    off: '#eefcfa',
    light: '#26a69a',
    background: '#E5F6F4',
    dark: '#00796b',
  },
  elf: {
    start: '#0b8475',
    middle: '#309c80',
    end: '#96d4b0',
  },
  yellow: {
    off: '#fef9e6',
    border: '#F3EDD4',
    light: '#E9C755',
    dark: '#FFC041',
  },
  grey: {
    greyF4: '#f4faf4',
    dark: '#63778B',
    iconBg: '#EBF2F9',
    aaa: '#aaaaaa',
    efefef: '#efefef',
    ddd: '#dddddd',
    grey4D: '#b0bec54d',
    grey78: '#787880',
    grey85: '#d9d9d9',
  },
  text: {
    light: '#889ea8',
    medium: '#78909C',
    dark: '#031a32',
    darkest: '#31363c',
    pending: '#f37b0c',
    grey: '#526982',
  },
  color: {
    black: '#000000',
    white: '#ffffff',
    smokeWhite: '#FAFBFD',
    divider: '#ebf2f9',
    border: '#d0dae4',
    darkBorder: '#A3B4C7',
    borderLight: '#E3E9EF',
    loyalty: '#e5e5e5',
    bar: '#ff9142',
    icon: '#3d4954',
    rating: '#f9c200',
    ratingAlpha: '#F9C2004D',
    red: '#e15241',
    lightGray: '#e3e9ef',
    darkGrayBlack: '#231F20',
    extraLightGray: '#f7f9fa',
    green: '#4cac51',
    shadow: '#0D345A',
    brandShadow: '#0E1F0E',
    bannerBorder: '#ededed',
    astercoreYellow: '#B9811C',
    astercoreGreen: '#09A5A8',
    astercoreYellowAlpha: '#B9811C1F',
    orange: '#E35209',
    blueIceberg: '#E2F6F6',
    oldLace: '#FDF9E7',
  },
  mandalay: {
    dark: '#B9811C',
    grey: '#F4F8FC',
    iconBg: '#F9F5ED',
  },
  verification: {
    orange: {
      off: '#fef7f0',
      main: '#f37b0c',
      border: '#FCEBD9',
    },
    green: {
      off: () => lightTheme.green.off,
      main: () => lightTheme.green.dark,
    },
    red: {
      off: '#fdf1f0',
      main: '#e15241',
    },
  },
  sectionBox: {
    bodyBg: '#fbfdff',
    gradientStart: '#f1f6fb',
    gradientEnd: '#ffffff00',
    gradientLight: '#F9FBFD',
  },
  clinic: {
    type: '#4C5864',
    distance: '#838C94',
  },
  blurBg: {
    blue: '#e8f1fb',
  },
  rightSideBar: {
    footerShadow: '0px -5px 40px #1976d214',
    bodyBg: () => lightTheme.sectionBox.bodyBg,
  },
  ErrorPage: {
    bgColor: '#fafcfd',
    blue: '#0957A8',
    green: '#4AB657',
  },
  bookingPage: {
    slotTime: '#171930',
  },
  royalBlue: {
    dark: '#1B254C',
    medium: '#DFE3F1',
    light: '#F4F6FA',
    off: '#F0F2FA',
    blueDianne: '#21394F',
    DarkBlueGray: '#31363C',
    darkGrey: '#607285',
    darkestBlue: '#384875',
    lightGrey: '#dfe4f1',
    borderGrey: '#a4bcfe',
  },
  revampPage: {
    backgroundColor: '#e9f0f7',
    borderColor: '#007bff',
    circle: '#f0f0f0',
    selectedBg: '#333',
    previousText: '#3c4043',
  },
  cdmLanding: {
    backgroundColor: '#eafff9',
    yourText: '#172048',
    stepMainText: '#453C3C',
  }
};

export default lightTheme;
